import axios from 'axios';
import sesionService from '@/services/SesionService';

export default {
	async getAllTags() {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get('/tags/all', HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getTagById(payload) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get(`/tags/${payload.id}`, HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async postTag(payload) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.post('/tags', payload, HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async putTag(payload) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.put(`/tags/${payload.id}`, payload, HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	}
};
